import Swal from "sweetalert2";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { WarningTriangleOutline } from "iconoir-react";
import { domain } from "../../../Urls/Services/Api_urls";
import { showTvCompatibilityModal } from "../../../service/tvCompatibilityMessage";

export const EmpaquetarLogin = (e) => {
  // Modal de empaquetar desde el navbar dentro de la app
  const isTvCard = Boolean(e?.isTvCard);
  const estrato = window.sessionStorage.getItem("estrato");
  const CITI = window.sessionStorage.getItem("city_owner");
  const cdo = window.sessionStorage.getItem("cdo");
  const zone = window.sessionStorage.getItem("zone");
  const adress = window.sessionStorage.getItem("direction");
  const email = window.sessionStorage.getItem("emailRes") !== null ? window.sessionStorage.getItem("emailRes") : window.sessionStorage.getItem("email");
  const cedula = window.sessionStorage.getItem("cedulaRes");
  const celular = window.sessionStorage.getItem("phoneRes");
  const nombreCompleto = window.sessionStorage.getItem("namedasRes");
  const partes = nombreCompleto.split("  ");
  const name = partes[0];
  const last_name = partes.slice(1).join(" ");
  const suscri = window.sessionStorage.getItem("cont");
  const token = window.sessionStorage.getItem("token");
  const localization = window.sessionStorage.getItem("localization");
  const empaquetarin = true;
  const precio = e.precio_persona;
  let mess = "";

  var today = new Date();
  var year = today.getFullYear();
  let password = `Emcali${year}*`;
  let valor_plan = "";
  let tarifa_plena = "";
  if (e.descuento != null) {
    valor_plan = parseInt(e.descuento_valor[e.estrato]);
    //tarifa_plena = e.json_valor.residencial[estrato]; falta probar
    tarifa_plena = e.json_valor && e.json_valor.residencial ? e.json_valor.residencial[e.estrato] : e.precio_persona[e.estrato];
  } else {
    valor_plan = parseInt(precio[e.estrato]);
  }

  let observacionesTexto = "";

  if (e.descuento) {
    const megasText = (e.megas && e.megas !== 0) ? ` y ${e.megas} MB adicionales` : '';
    observacionesTexto = `Aplica ${e.descuento}% de descuento por ${e.months} meses${megasText}\npor ${e.discount_months} meses. Posteriormente, se aplicará la tarifa plena\nvigente de ${new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(Math.trunc(tarifa_plena))} y las megas correspondientes.`;
  } else {
    observacionesTexto = "No aplica descuento.";
  }

  const warningIcon = renderToStaticMarkup(
    <WarningTriangleOutline width={16} height={16} style={{ color: "#d97706", flexShrink: 0 }} />
  );

  const campoArchivo = (inputId) => `
        <style>.btn-archivo{background-color:#e9ecef;color:#212529;border:1px solid #ced4da;border-radius:.375rem 0 0 .375rem;}.btn-archivo:hover:not(:disabled){background-color:#d3d9df;color:#212529;}.btn-archivo:focus-visible,.btn-archivo:active{background-color:#e9ecef;color:#212529;border-color:#ced4da;}</style>
        <input id="${inputId}" type="file" style="display:none">
        <div class="input-group">
            <button type="button" class="btn btn-archivo" id="${inputId}-cargar">Cargar archivo</button>
            <div class="form-control" id="${inputId}-nombre" style="text-align:left; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                <span style="color:#6c757d">Seleccionar archivo</span>
            </div>
        </div>`;

  const showSolicitudServicioModal = () => {
    Swal.fire({
      title: "Solicitar Servicio",
      html:
        `
                <form>
                <div class="m-3">
                    <div class="row mb-3">
                    <div class="col-6 mb-3">
                    <label for="NameLabelUpdate" class="labelFount">Propietario Nombre</label>
                    <input type="text" id="swal-input1" class="form-control" placeholder="Propietario" value="` +
      name +
      `">
                </div>
                <div class="col-6 mb-3">
                      <label for="NameLabelUpdate" class="labelFount">Propietario Apellido</label>
                      <input type="text" id="swal-input10" class="form-control" placeholder="Propietario" value="` +
      last_name +
      `">
                  </div>
                  <div class="mb-3" >
                  <label for="NameLabelUpdate" class="labelFount">Tipo de documento</label>
                  <div class="" style="display: flex; justifyContent: center; ">
                  <select class="select" id="status" style="width: 100%; height: 2.4rem; border: 0.5px solid #E0E0E0; border-radius:4px; background-color: #fff; padding: 0.75rem;">
                    <option value="2">Cedula de Ciudadania</option>
                    <option value="3">NIT</option>
                    <option value="4">Tarj de Identidad</option>
                    <option value="5">Registro Civil</option>
                    <option value="6">Ced de Extrageria</option>
                    <option value="7">Pasaporte</option>
                    <option value="8">NUIP</option>
                    <option value="9">Codigo DANE</option>
                  </select>
                  </div>
                </div>
                        <div class="col-12">
                            <label for="NameLabelUpdate" class="labelFount">Documento</label>
                            <input ${cedula ? 'disabled' : ''} type="number" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="` +
      cedula +
      `">
                            <div style="display: flex; align-items: center; gap: 0.35rem; flex-wrap: wrap; font-size: 0.9rem; text-align: left; margin-top: 0.6rem; margin-bottom: 0.4rem;">
                              ${warningIcon}
                              <strong>Verifica la identidad del cliente.</strong>
                              <a href="https://www.procuraduria.gov.co/Pages/consulta-de-antecedentes.aspx" target="_blank" rel="noopener noreferrer">Consulta de antecedentes</a>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount">CEL Propietario</label>
                          <input type="number" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="` +
      celular +
      `">
                      </div>
                      
                    </div>
                    <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount">Correo propietario</label>
                          <input disabled type="email" id="swal-input5" class="form-control" placeholder="Correo propietario" value="` +
      email +
      `">
                      </div>
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                        ${campoArchivo("swal-input6")}
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara frontal</label>
                        ${campoArchivo("swal-input7")}
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara posterior</label>
                        ${campoArchivo("swal-input8")}
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Plan</label>
                        <h5>` +
      e.nombreplan +
      `</h5>
                        <h5>$` +
                        valor_plan +
      `</h5>
                    </div>
    
                    <div class="row mb-4">
                      <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                      <textarea id="swal-input9" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER" >${observacionesTexto}</textarea>
                    </div>
                </div>
            </form>
          `,
      confirmButtonText: "Comprar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#655CC9",
      showCancelButton: true,
      focusConfirm: false,
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        ["swal-input6", "swal-input7", "swal-input8"].forEach((id) => {
          const input = document.getElementById(id);
          const nombre = document.getElementById(`${id}-nombre`);
          document.getElementById(`${id}-cargar`).addEventListener("click", () => input.click());
          input.addEventListener("change", () => {
            if (input.files[0]) nombre.textContent = input.files[0].name;
          });
        });
      },
      preConfirm: async () => {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const RES = {
        name: document.getElementById("swal-input1").value,
        last_name: document.getElementById("swal-input10").value,
        dni: document.getElementById("swal-input2").value,
        phone: document.getElementById("swal-input3").value,
        password: password,
        username: document.getElementById("swal-input5").value,
        action: "UnifiedSaleUser",
      };

      var formdata = new FormData();
      formdata.append("package", empaquetarin);
      formdata.append("phone_fijo", celular);
      formdata.append("address", adress);
      formdata.append("name", document.getElementById("swal-input1").value);
      formdata.append(
        "last_name",
        document.getElementById("swal-input10").value
      );
      formdata.append("type_ide", document.getElementById("status").value);
      formdata.append("cc", document.getElementById("swal-input2").value);
      formdata.append(
        "contact_phone",
        document.getElementById("swal-input3").value
      );

      formdata.append(
        "email_owner",
        window.sessionStorage.getItem("emailRes") !== null
          ? window.sessionStorage.getItem("emailRes")
          : document.getElementById("swal-input5").value
      );

      formdata.append("estrato", estrato);
      formdata.append("city_owner", CITI);
      formdata.append("price_plan", valor_plan);
      formdata.append("ad_cc", document.getElementById("swal-input7").files[0]);
      formdata.append(
        "ad_cc_back",
        document.getElementById("swal-input8").files[0]
      );
      formdata.append("category", "Residencial");
      formdata.append(
        "rec_pub",
        document.getElementById("swal-input6").files[0]
      );
      formdata.append("plan", e.nombreplan);
      formdata.append(
        "observations",
        document.getElementById("swal-input9").value
      );
      formdata.append("localization", localization);
      formdata.append("cdo", cdo);
      formdata.append("zone", zone);
      formdata.append("id_plan", e.id__planes);
      formdata.append("plan_type", e.tipoplan);
      formdata.append("id_plan_open", e.codigo_open);
      formdata.append(
        "user_creation",
        window.sessionStorage.getItem("idusercreationRes")
      );
      formdata.append("contract", suscri);
      formdata.append(
        "seller",
        window.sessionStorage.getItem("seller") !== null
          ? window.sessionStorage.getItem("seller")
          : ""
      );

      const registrado = window.sessionStorage.getItem("Register");
      if (registrado === "No") {
        try {
          const regResponse = await fetch(domain + "/user/register/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(RES),
          });
      
          const regData = await regResponse.json();
      
          if (regResponse.status !== 201) {
            if (regData.msg) {
              let htmlMessage = "<ul>";
              for (let key in regData.msg) {
                const details = Array.isArray(regData.msg[key]) ? regData.msg[key].join(", ") : regData.msg[key];
                htmlMessage += `<li><strong>${key}:</strong> ${details}</li>`;
              }
              htmlMessage += "</ul>";
              Swal.showValidationMessage(htmlMessage);
              return false;
            } else {
              Swal.showValidationMessage("Error durante el registro del usuario.");
              return false;
            }
          }
      
          // Registro exitoso
          formdata.append("user_creation", regData.user_creation);
      
          const portalResponse = await fetch(domain + "/portal/", {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          });
      
          const portalText = await portalResponse.text();
      
          if (!portalResponse.ok) {
            try {
              const portalData = JSON.parse(portalText);
              if (portalData.msg) {
                let htmlMessage = "<ul>";
                for (let key in portalData.msg) {
                  const details = Array.isArray(portalData.msg[key]) ? portalData.msg[key].join(", ") : portalData.msg[key];
                  htmlMessage += `<li><strong>${key}:</strong> ${details}</li>`;
                }
                htmlMessage += "</ul>";
                Swal.showValidationMessage(htmlMessage);
                return false;
              } else {
                Swal.showValidationMessage("Error al crear la solicitud.");
                return false;
              }
            } catch (e) {
              Swal.showValidationMessage("Error inesperado en la respuesta del servidor.");
              return false;
            }
          }
      
          // Todo exitoso
          Swal.fire({
            title: "Registro exitoso",
            text: "Te contactarán próximamente para agendar tu instalación",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ver solicitud",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/Solicitud/";
            }
          });
        } catch (error) {
          Swal.showValidationMessage(`Error: ${error.message}`);
          return false;
        }
      }
       else {
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        console.log("usuario registrado")
        // {"status":400,"type":"error","msg":"This QueryDict instance is immutable"}
        return fetch(domain + "/portal/", requestOptions)
          .then(async (response) => {
            let errorMsg = "";
            if (!response.ok) {
              const responseBody = await response.text();

              try {
                errorMsg = JSON.parse(responseBody);

                if (errorMsg.msg) {
                  let htmlMessage = "<div style='display: flex; flex-direction: column;'>";
                  htmlMessage += "<ul>";
                
                  for (let key in errorMsg.msg) {
                    if (errorMsg.msg.hasOwnProperty(key)) {
                      const errorDetails = Array.isArray(errorMsg.msg[key])
                        ? errorMsg.msg[key].join(", ")
                        : errorMsg.msg[key];
                      htmlMessage += `<li><strong>${key}:</strong> ${errorDetails}</li>`;
                    }
                  }
                
                  htmlMessage += "</ul></div>";
                
                  Swal.showValidationMessage(htmlMessage);
                }
                              
              } catch (error) {
                throw new Error(
                  `${mess}`
                );
              }
            } else {
              Swal.fire({
                title: "Registro exitoso",
                text: "Te contactarán próximamente para agendar tu instalación",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ver solicitud",
                // timer: 4000,
              }).then((result) => {
                if (result.isConfirmed) {
                  sessionStorage.getItem("groups") === "Usuario"
                    ? (window.location.href = "/Solicitud/")
                    : (window.location.href = "/Dashboardprincipal");
                }
              });
            }
          })
          .catch((error) => {
            Swal.showValidationMessage(`${error.message}`);
          });
      }
      },
    });
  };

  if (isTvCard) {
    showTvCompatibilityModal(e.nombreplan, showSolicitudServicioModal);
  } else {
    showSolicitudServicioModal();
  }
};

// ## Summary
// This code defines a function named `EmpaquetarLogin` that is used to handle a form submission. It retrieves data from the session storage and creates a form using the retrieved data. The form is displayed using a modal dialog from the SweetAlert2 library. When the user submits the form, the function sends a POST request to an API endpoint with the form data. If the request is successful, a success message is displayed, otherwise an error message is shown.

// ## Example Usage
// ```javascript
// EmpaquetarLogin(event);
// ```

// ## Code Analysis
// ### Inputs
// - `e` (event): The event object representing the form submission.
// ___
// ### Flow
// 1. Retrieve various data from the session storage.
// 2. Split the full name into first name and last name.
// 3. Determine the password based on the current year.
// 4. Create a form using the retrieved data and HTML markup.
// 5. Display the form using a modal dialog.
// 6. When the user submits the form:
//    - Retrieve the form data.
//    - Create a FormData object and append the form data to it.
//    - Send a POST request to the API endpoint with the form data.
//    - If the request is successful, display a success message and redirect the user.
//    - If the request fails, display an error message.
// ___
// ### Outputs
// - None. The function performs actions based on user interaction and API responses.
// ___
